import styled from 'styled-components';
import background from '../../../assets/images/maze-bacground.svg'
export const Body = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    padding-bottom: 65px;
`

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 80vw;
    align-items: flex-start;
`
export const LessonInfo = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
    justify-content: center;
    margin-bottom: 5em;
    
    i {
        font-size: 36px;
        color: #ff0033;
        cursor: pointer;
    }
    div.lesson-info {
        margin-right: 3em;
        color: #fff;

        h1.lesson-name {
            font: bold italic 26px 'Roboto Condensed';
            text-transform: uppercase;
            text-align: center;
        }
        p.lesson-description {
            font: bold normal 18px 'Roboto Condensed';
            text-align:center;
        }
    }
`
export const ScreensList = styled.div`
    width: 30%;
`

export const ScreenListItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: ${props => props.bgColor};
    color: #fff;
    width: 90%;
    height: 40px;
    border-radius: 5px;
    margin-bottom: 8px;
    padding: 0 16px;

    p {
        text-transform: uppercase;
        font: normal normal 18px 'Roboto Condensed';
        text-align: center;
        margin: 0 !important;
        width: 85%;
        white-space: nowrap;
        overflow-x: hidden;
    }
    div {
        display: flex;
        width: 45px;
        align-items: center;
        justify-content: space-between;
        
        img {
        height: 14px;
        cursor: pointer;
    }
    }

`

export const Header = styled.div`
    min-height: 40px;
`
export const BuilderContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 32px;
    align-items: center;
    background-color: ${props => props.bgColor};
    width: 100%;
    border-radius: 5px;
` 
export const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${props => props.justify ? props.justify : ''};
    width: 100%;
    height: 100%;
    padding: 16px;
    border: 2px solid #ffffff40;
    border-radius: 5px;
    margin-bottom: 16px;
    background-color: ${props =>  props.bgColor ? props.bgColor : ''};
`
export const Row = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`
export const DnDContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`
export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    width: ${props => (100 / props.cols) - 2}%;

    p {
        font: normal normal 16px 'Roboto Condensed';
        margin-bottom: 0 !important;
    }
`

export const PreviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    background-color: ${props => props.bgColor};
    border: 32px solid #fff;
    color: #fff;
    width: 90%;
    min-height: 80%;
    overflow-y: scroll;
    padding: 16px 32px;
`

export const PreviewRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;

    div {
        margin-right: 16px;
    }
`
export const Button = styled.button`
    height: 40px;
    width: 200px;
    border-radius: 5px;
    border: 2px #fff solid;
    background-color: rgba(255, 255, 255, .2);
    font: normal normal 22px 'Roboto Condensed';
    text-transform: uppercase;
    color: #fff;
    margin: auto;
`

export const NextButton = styled.button`
    height: 60px;
    width: 300px;
    border-radius: 10px;
    border: 2px #fff solid;
    background-color: rgba(255, 255, 255, .2);
    font: normal normal 22px 'Roboto Condensed';
    text-transform: uppercase;
    color: #fff;

    :focus, :hover, :active {
        background-color: rgba(255, 255, 255, .4);
    font: normal normal 22px 'Roboto Condensed';
    text-transform: uppercase;
    color: #fff;
    border: 2px #fff solid;

    }
`

export const StyledSelect = styled.select`
    border: 1px solid #fff;
    font-family: "Roboto";
  display: block !important;
  width: 100%;
  background: transparent;
  color: #fff;
  height: 45px;
  border-radius: 2px;
  padding-left: 1em !important;
  margin-top: 1.25em;
  margin-bottom: 0.5em;
  -webkit-appearance: menulist-button;
  -moz-appearance: menulist;

  :active, :focus {
    box-shadow: 0 1px 10px 1px rgba(255, 255, 255, 0.767) !important;
    border: 1px solid #fff !important;
    outline: none;
  }
`

export const StyledOption = styled.option`
color: ${props => props.color};
font-size: 22px;
font-weight: bold;

`

export const FabButton = styled.button`
  align-self: flex-end;
  width: 90px;
  height: 90px;
  position: sticky;
  bottom: 60px;
  right: 30px;
  border-radius: 50%;
  border: none;
  background-color: ${props => props.bgColor};
  z-index: 1000;
  box-shadow: 2px 2px 5px #000;
  color: #fff;
  transition: transform 300ms ease;

  :hover, :active, :focus {
      border-radius: 50%;
      color: #fff;
      transform: scale(1.1);
  }
`

export const InteractionListItem = styled.p`
  color: ${props => props.isCurrent ? '#000' : '#fff'};
  margin: .25em;
  background-color: ${props => props.isCurrent ? '#acff24' : props.isChosen ? "#3ee9f7" : '#ececec20'};
  padding: 1em;

  :hover {
      background-color: #ffffff70;
  }

  span {font-weight: bold}
`





// WEBPACK FOOTER //
// ./src/pages/Admin/LessonBuilder/LessonBuilder.styles.ts